import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import apiClient from "../../utils/axiosClient";

interface Props {
  children: React.ReactNode;
}

const isValidToken = (token: string | null) => {
  return !!token && token.split(".").length === 3; // JWT 토큰은 3부분으로 나뉨
};

const ProtectedRoute = ({ children }: Props) => {
  const [status, setStatus] = useState<"checking" | "authed" | "unauthed">("checking");

  useEffect(() => {
    const existingToken = sessionStorage.getItem("avatye:ops:admin:accessToken");
    if (isValidToken(existingToken)) {
      setStatus("authed");
      return;
    }

    // 세션스토리지에 없으면, refreshToken 쿠키(HttpOnly)로 accessToken 재발급 시도
    apiClient
      .post("/api/v1/auth/refresh")
      .then((res) => {
        sessionStorage.setItem("avatye:ops:admin:accessToken", res.data.access_token);
        setStatus("authed");
      })
      .catch(() => setStatus("unauthed"));
  }, []);

  if (status === "checking") {
    return null;
  }

  if (status === "unauthed") {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>; // React.ReactNode는 Fragment로 감싸야 안전
};

export default ProtectedRoute;
